<div class="header_menu" *ngIf="showHeader$ | async">
    <trpx-header-menu class="position-relative" *ngIf="hideHeader"></trpx-header-menu>
</div>
<router-outlet (activate)="onActivate($event)"></router-outlet>


<trpx-footer class="position-relative" *ngIf="hideFooter" [class.d-none]="!(showFooter$ | async)" [class.d-md-block]="!(showFooter$ | async)"></trpx-footer>